import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { Reveal, SectionHead } from "@/components/motion";

export const Markets = () => {
  const { t } = useI18n();
  const m = t.markets;
  return (
    <section className="bg-[var(--night)] py-24 lg:py-32" data-testid="markets-section">
      <div className="container-x">
        <SectionHead index="08" eyebrow={m.eyebrow} title={m.title} />
        <div className="mt-14 grid grid-cols-1 gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
          {m.items.map((x, i) => (
            <Reveal key={x.t} delay={(i % 4) * 0.05} className="group bg-[var(--night)] p-7 transition-colors duration-500 hover:bg-[var(--navy)]">
              <p className="font-mono text-xs text-[var(--gold)]">{String(i + 1).padStart(2, "0")}</p>
              <p className="font-display mt-8 text-3xl font-bold uppercase leading-none" data-testid={`market-${i + 1}`}>{x.t}</p>
              <p className="mt-3 text-sm text-[var(--steel-dim)]">{x.d}</p>
            </Reveal>
          ))}
          <Link to="/commander" data-testid="markets-cta" className="group flex flex-col justify-between bg-[var(--gold)] p-7 text-[var(--night)]">
            <ArrowUpRight className="h-8 w-8 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
            <p className="font-display mt-8 text-3xl font-black uppercase leading-none">{m.cta}</p>
          </Link>
        </div>
      </div>
    </section>
  );
};
